import { render, staticRenderFns } from "./66.vue?vue&type=template&id=04cbe104&scoped=true&"
var script = {}
import style0 from "./66.vue?vue&type=style&index=0&id=04cbe104&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cbe104",
  null
  
)

export default component.exports